import { IonToolbar, IonTitle, IonButtons } from "@ionic/react";
import React from "react";
import { useSelector } from "react-redux";
import { selectLocation } from "../../../store/locationShow/selectors/selectLocation";

export const HeaderSection: React.FC = () => {
  const location = useSelector(selectLocation);
  return (
    <IonToolbar>
      <IonTitle>{location?.name}</IonTitle>
      <IonButtons></IonButtons>
    </IonToolbar>
  );
};
